import Help from './Help.vue';

const routes = [
  {
    path      : '/help',
    name      : 'Help',
    component : Help,
    meta      : {
      isPublic: true
    }
  }
];

export default routes;
